angular.module('bmsApp.trugreen').factory('TGCancelReasonSvc', function ($q,
																		 CRUDSvc) {

	var self = {
		options: function () {
			return CRUDSvc.get('api/trugreen/cancelReason/options');
		}
	};
	return self;

});
